<div class="tab-pane" role="tabpanel" id="ampliacion">
    <fieldset id="agregar_ampliacion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Antecedentes de la Ampliacion</strong></h3>
                        <hr>
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label for="sup_permiso" class="col-md-3" align="left" style="padding-top: 20px;">Superficie Vivienda existente con Permiso y Recepcion Definitiva (m2)</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superf. Permiso" id="sup_permiso" name="sup_permiso" formControlName="sup_permiso" >
                                    </mat-form-field>
                                </div>
                                <label for="superf_terreno" class="col-md-3" align="left" style="padding-top: 20px;">Superficie Terreno</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superf. Terreno" id="superf_terreno" name="superf_terreno" formControlName="superf_terreno" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group">
                                <div class="col-md-7" align="center">
                                    <label for="superf_edificada">Superficie Edificada</label>
                                </div>
                                <div class="col-md-5" align="left">
                                    <label for="superf_edificada">Superficie Ampliacion</label>
                                </div>
                            </div>
                            <br>
                            <div class="col-md-12"></div>
                            <div class="form-group">
                                <div class="col-md-4"> <label for="existente" class="col-md-12" align="center" style="padding-bottom: 15px">Existente</label></div>
                                <div class="col-md-2"> <label for="ampliacion" class="col-md-12" align="center" style="padding-bottom: 15px">Ampliacion</label></div>
                            </div>
                            <div class="form-group">


                                <div class="col-md-12">
                                    <div class="col-md-2"><label for="pisos1" align="left" style="padding-top: 20px;">1er Piso</label></div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="1er piso ex" id="piso1_ex" name="piso1_ex" formControlName="piso1_ex" >
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="1er piso ampl" id="piso1_amp" name="piso1_amp" formControlName="piso1_amp" >
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1"></div>
                                    <div class="col-md-5" align="left">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Superf. Ampl" id="superf_amp" name="superf_amp" formControlName="superf_amp" >
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">

                                <div class="col-md-12">
                                    <div class="col-md-2"><label for="pisos2" align="left" style="padding-top: 20px;">2do Piso</label></div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="2do piso ex" id="piso2_ex" name="piso2_ex" formControlName="piso2_ex" >
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="2do piso ampl" id="piso2_amp" name="piso2_amp" formControlName="piso2_amp" >
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6"></div>
                                </div>
                                <div class="col-md-12">


                                    <div class="col-md-2"><label for="piso3" align="left" style="padding-top: 20px;">3er Piso</label></div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="3er piso ex" id="piso3_ex" name="piso3_ex" formControlName="piso3_ex" >
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="3do piso ampl" id="piso3_amp" name="piso3_amp" formControlName="piso3_amp" >
                                        </mat-form-field>
                                    </div>

                                    <div class="col-md-6"></div>
                                </div>
                            </div>

                            <hr>
                            <div class="form-group" align="left">
                                <label for="condominio" class="col-md-4">La Vivienda Social forma parte de un condominio (ley 19537)</label>
                                <div class="col-md-1"></div>
                                <div class="inline">
                                    <div class="inline">
                                        <mat-radio-group formControlName="condominio">
                                            <mat-radio-button style="padding-right: 20px" name="condominio" value="SI">SI</mat-radio-button>
                                            <mat-radio-button style="padding-right: 20px" name="condominio" value="NO">NO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group" align="left">
                                <label for="economica" class="col-md-4">La Vivienda que se amplia mantiene su condicion de vivienda Economica (hasta 140 m2)</label>
                                <div class="col-md-1"></div>
                                <div class="inline">
                                    <div class="inline">
                                        <mat-radio-group formControlName="economica">
                                            <mat-radio-button style="padding-right: 20px" name="economica" value="SI">SI</mat-radio-button>
                                            <mat-radio-button style="padding-right: 20px" name="economica" value="NO">NO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-7" align="right" style="padding-top: 30px; padding-bottom: 20px;">
                                        <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_ampliacion" (click)="add_ampliacion()">
                                                Agregar Ampliacion
                                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF. PERMISO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.sup_permiso}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF. TERRENO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_terreno}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF. AMPLIACION</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_amp}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>CONDOMINIO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.condominio == 'SI'">Si</strong>
                                    <strong *ngIf="row.condominio == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>VIV. ECONOM</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.economica == 'SI'">Si</strong>
                                    <strong *ngIf="row.economica == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_ampliacion(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_ampliacion(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>


    <ng-template #openModal>
        <h2 mat-dialog-title>Informaci&oacute;n de la Ampliaci&oacute;n</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion solicitada</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="sup_permiso">Superficie Permiso</label>
                    <div class="col-md-6">
                        <input id="num_amp" name="num_amp" type="hidden" placeholder="num_amp" class="form-control input-md" [(ngModel)]="temp_ampl.num_amp">
                        <input id="sup_permiso" name="sup_permiso" type="text" placeholder="sup_permiso" class="form-control input-md" [(ngModel)]="temp_ampl.sup_permiso">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="superf_terreno">Superficie Terreno</label>
                    <div class="col-md-6">
                        <input id="superf_terreno" name="superf_terreno" type="text" placeholder="superf_terreno" class="form-control input-md" [(ngModel)]="temp_ampl.superf_terreno">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso1_ex">1er Piso Existente</label>
                    <div class="col-md-6">
                        <input id="piso1_ex" name="piso1_ex" type="text" placeholder="piso1_ex" class="form-control input-md" [(ngModel)]="temp_ampl.piso1_ex">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso1_amp">1er Piso Ampliacion</label>
                    <div class="col-md-6">
                        <input id="piso1_amp" name="piso1_amp" type="text" placeholder="piso1_amp" class="form-control input-md" [(ngModel)]="temp_ampl.piso1_amp">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso2_ex">2do Piso Existente</label>
                    <div class="col-md-6">
                        <input id="piso2_ex" name="piso2_ex" type="text" placeholder="piso2_ex" class="form-control input-md" [(ngModel)]="temp_ampl.piso2_ex">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso2_amp">2do Piso Ampliacion</label>
                    <div class="col-md-6">
                        <input id="piso2_amp" name="piso2_amp" type="text" placeholder="piso2_amp" class="form-control input-md" [(ngModel)]="temp_ampl.piso2_amp">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso3_ex">3er Piso Existente</label>
                    <div class="col-md-6">
                        <input id="piso3_ex" name="piso3_ex" type="text" placeholder="piso3_ex" class="form-control input-md" [(ngModel)]="temp_ampl.piso3_ex">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="piso3_amp">3er Piso Ampliacion</label>
                    <div class="col-md-6">
                        <input id="piso3_amp" name="piso3_amp" type="text" placeholder="piso3_amp" class="form-control input-md" [(ngModel)]="temp_ampl.piso3_amp">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="superf_amp">Superficie de Ampliacion</label>
                    <div class="col-md-6">
                        <input id="superf_amp" name="superf_amp" type="text" placeholder="superf_amp" class="form-control input-md" [(ngModel)]="temp_ampl.superf_amp">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="condominio">Pertenece a un Condominio</label>
                    <div class="col-sm-2">
                        <label class="radio-inline"><input id="condominio" ng-control="condominio" name="condominio" type="radio" value="SI"  [(ngModel)]="temp_ampl.condominio" />SI</label>
                    </div>
                    <div class="col-sm-2">
                        <label class="radio-inline"><input id="condominio" ng-control="condominio" name="condominio" type="radio" value="NO"  [(ngModel)]="temp_ampl.condominio" />NO</label>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="economica">Vivienda Economica</label>
                    <div class="col-sm-2">
                        <label class="radio-inline"><input id="economica" ng-control="economica" name="economica" type="radio" value="SI"  [(ngModel)]="temp_ampl.economica" />SI</label>
                    </div>
                    <div class="col-sm-2">
                        <label class="radio-inline"><input id="economica" ng-control="economica" name="economica" type="radio" value="NO"  [(ngModel)]="temp_ampl.economica" />NO</label>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_ampliacion" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_ampliacion" (click)="saveAmpliacion()">Ingresar Ampliacion <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato de la ampliación.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<div class="separator"></div>